/* eslint-disable no-console */
import {Form, InputProps} from 'antd';
import React from 'react';
import PhoneInput from 'react-phone-input-2';
import 'react-phone-input-2/lib/high-res.css';

const PhoneNumberInput: React.FC<
  InputProps & {shouldCallonChange?: boolean}
> = ({value, onChange, disabled, shouldCallonChange = false, onBlur}) => {
  // const {setFields} = useFormInstance();
  const {status, errors} = Form.Item.useStatus();
  const handleChange = (newValue: any) => {
    if (onChange) {
      const plusValue = newValue.startsWith('+') ? newValue : `+${newValue}`;
      if (!shouldCallonChange) {
        onChange(plusValue);
      } else {
        onChange({target: {value: plusValue}} as any);
      }
      // const isValid = validationOfMobileNumbers(plusValue, countryData);
      // if (typeof isValid === 'string') {
      // setFields([
      //   {
      //     name,
      //     value: plusValue
      //     // errors: [isValid]
      //   }
      // ]);
      // }
    }
  };

  return (
    <PhoneInput
      country={'in'}
      containerClass={`react-tel-input custom-input-${status}`}
      value={value as string | null | undefined}
      onChange={handleChange}
      countryCodeEditable={false}
      copyNumbersOnly={false}
      disabled={disabled}
      placeholder="Enter Mobile Number"
      prefix="+"
      inputStyle={{
        width: '100%'
      }}
      // inputProps={{
      //   ref: null
      // }}
      containerStyle={{
        width: '100%'
      }}
      onFocus={(e) => {
        if (errors.length === 0) {
          e.target.style.borderColor = '#3bb3c1';
          e.target.style.borderLeft = '1px solid blue';
        }
      }}
      onBlur={(e) => {
        if (onBlur) {
          onBlur(e);
        }
        e.target.style.borderColor = '';
      }}
    />
  );
};

export default PhoneNumberInput;
